import React, { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import { Checkbox, NavHeader, Page } from '../../components';
import { PinInput } from '../../components/pin-input/pin-input';
import { DEMO } from '../../const';

const Demo: React.FC = () => {
  const [pin, setPin] = useState<string>('');
  const [demoPushNotifications, setDemoPushNotifications] = useState<boolean>(
    !!localStorage.getItem('demoPushNotifications'),
  );
  const [ecoTile, setEcoTile] = useState<boolean>(!!localStorage.getItem('ecoTile'));
  const [ecoPoints, setEcoPoints] = useState<boolean>(!!localStorage.getItem('ecoPoints'));
  const [tariffComparator, setTariffComparator] = useState<boolean>(!!localStorage.getItem('tariffComparator'));
  const [newMeter, setNewMeter] = useState<boolean>(!!localStorage.getItem('newMeter'));

  const handleChange = (
    property: string,
    setState: Dispatch<SetStateAction<boolean>>,
    e: ChangeEvent<HTMLInputElement>,
  ) => {
    const { checked } = e.target;
    setState(checked);

    if (checked) localStorage.setItem(property, 'true');
    else localStorage.removeItem(property);
  };

  const renderCheckbox = (
    checked: boolean,
    property: string,
    setState: Dispatch<SetStateAction<boolean>>,
    title: string,
  ) => (
    <Checkbox checked={checked} reverse onChange={(e) => handleChange(property, setState, e)}>
      <p>{title}</p>
    </Checkbox>
  );

  return (
    <Page isStickyHeader header={<NavHeader title="Demo" />}>
      <>
        {pin !== DEMO ? (
          <PinInput pin={pin} onChange={setPin} />
        ) : (
          <>
            {renderCheckbox(demoPushNotifications, 'demoPushNotifications', setDemoPushNotifications, 'Demo push')}
            {renderCheckbox(ecoTile, 'ecoTile', setEcoTile, 'Kafelek eko')}
            {renderCheckbox(ecoPoints, 'ecoPoints', setEcoPoints, 'Grywalizacja (punkty)')}
            {renderCheckbox(tariffComparator, 'tariffComparator', setTariffComparator, 'Porównywarka taryf')}
            {renderCheckbox(newMeter, 'newMeter', setNewMeter, 'Nowy typ miernika')}
          </>
        )}
      </>
    </Page>
  );
};

export default Demo;
